/* eslint-disable no-self-assign */
/* eslint-disable require-yield */

// import get from 'lodash/get'
import auditlogApi from '@/api/auditlog'
import get from 'lodash/get'

const INITIAL_STATE = {
  auditlogList: null
}

export default {
  namespace: 'auditlog',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setAuditlogData(state, { payload }) {
      return { ...state, auditlogList: payload }
    },
  },

  effects: {
    *getAuditlogData({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(auditlogApi.getAuditlogData, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let hasError = true

      if (status === 200) {
        hasError = false
        yield put({ type: 'auditlog/setAuditlogData', payload: resData })
        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *reportDownload({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(auditlogApi.reportDownload, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response

      let error = {}

      if (status === 200) {
        error = null
        successCallback?.(resData)
      }
      if (error) {
        errorCallback?.(error)
      }
    },

  },
}
